<template>
    <div id="collapsible-panel">
        <div id="panel-header" @click="collapse()">
            <div class="panel-title">
                <div class="panel-info" v-if="panel.info" :title="panel.info" :alt="panel.info">
                    <i class="info-icon fas fa-info-circle"></i> - 
                </div>
                {{title}}
            </div>
            <div v-show="collapsed" class="up-arrow"><i class="fa fa-chevron-up"></i></div>
            <div v-show="!collapsed" class="down-arrow"><i class="fa fa-chevron-down"></i></div>
        </div>
        <div id="panel-content" v-if="!collapsed">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name:"CollapsiblePanelComponent",
    props:['panel', 'folded'],
    created(){
        this.collapsed = this.folded;
        if(this.panel.fullscreen === null || this.panel.fullscreen === undefined){
            this.panel.fullscreen = false;
        }
    },
    data(){
        return {
            collapsed:false
        }
    },
    computed:{
        title(){
            let title = this.panel.title;
            if(this.panel.subtitle){
                title += ' - '+this.panel.subtitle;
            }
            return title;
        }
    },
    methods:{
        collapse:function(){
            if(!this.panel.fullscreen){
                this.collapsed = !this.collapsed;
                this.$emit("collapsed", this.collapsed);
                this.$emit("update:collapsed", this.collapsed);
            }
        }
    }
}
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

#collapsible-panel{
    margin: 15px 10px;
    padding: 5px;
    border: 1px solid hsla(0, 0%, 75%, 1);
    border-radius: 5px;

    #panel-header{
        display: grid;
        grid-template-columns: 95% 5%;
        padding: 10px;
        cursor: pointer;
        user-select: none;

        .panel-info{
            display: inline;
            cursor: help;
            .info-icon{
                color: @vermelho;
                font-size: 1.2rem;
            }
        }
    }

}
</style>